import Vue from 'vue'
import Router from 'vue-router'
import AuthRoutes from './views/pages/Auth/routes'
import moment from 'moment'
import { checkMigrationAndRedirect } from './config/v2'
import {
  checkEquipmentMigration,
  setPendingQrCode,
} from './config/qrCodeRedirect'

import StandardChecklistRoutes from './views/pages/StandardChecklist/router'
import PatchNoteRoutes from './views/pages/PatchNotes/router'
import CalendarRoutes from './views/pages/Calendar/router'
import CalibrationRoutes from './views/pages/Calibration/router'
import CalledsRoutes from './views/pages/Calleds/router'
import ChecklistsRoutes from './views/pages/Checklists/router'
import ContractsRoutes from './views/pages/Contracts/router'
import DashboardRoutes from './views/pages/Dash/router'
import DashboardBIRoutes from './views/pages/DashboardBI/router'
import EquipmentRoutes from './views/pages/Equipment/router'
import ReportsRoutes from './views/pages/Reports/router'
import ServiceOrdersRoutes from './views/pages//ServiceOrders/router'
import TasksRoutes from './views/pages/Tasks/router'
import UsersRoutes from './views/pages/Users/router'
import UnidadesRoutes from './views/pages/Unidade/router'
import CalibrationMetricsRoutes from './views/pages/CalibrationMetrics/router'
import StandardEquipamentRoutes from './views/pages/StandardEquipment/router'
import DepartmentRoutes from './views/pages/Department/route'
import SupplierRoutes from './views/pages/Suppliers/router'
import UploadDocumentRoutes from './views/pages/UploadDocument/router'
import AlertRoutes from './views/pages/Alert/router'
import StockRoutes from './views/pages/Stock/router'
import ConsumptionRoutes from './views/pages/Consumption/router'
import AboutEquipmentQrCode from './views/pages/Equipment/components/AboutEquipmanentByQrCodeLink.vue'
import InstitutionRoutes from './views/pages/Institutions/router'
import ExternalFileControlRoutes from './views/pages/ExternalFileControl/router'
import EquipmentImportRoutes from './views/pages/EquipmentImport/router'
import CostCenter from './views/pages/CostCenter/router'
import ServiceOrderPrintView from './views/pages/ServiceOrders/components/serviceOrderPrintView/serviceOrderPrintView.vue'
import CalibrationPrintView from './views/pages/Calibration/components/calibrationCertifiedPrintView/calibrationCertifiedPrintView.vue'
import ChecklistPrintView from './views/pages/Checklists/components/checklistPrintView/checklistPrintView.vue'
import BigDataRoutes from './views/pages/BigData/router'
import ScheduleRoutes from './views/pages/Schedule/router'
import SolutionRoutes from './views/pages/Solutions/router'
import StandardManufacturerRoutes from './views/pages/StandardManufacturer/router'
import ManufacturerRoutes from './views/pages/Manufacturer/router'
import ReplacementStudyRoutes from './views/pages/ReplacementStudy/router'
import InspectionRoutineRoutes from './views/pages/InspectionRoutineChecklist/router'
import ChronogramRoutes from './views/pages/Chronogram/router'
import GeneratedReportRoutes from './views/pages/GeneratedReport/router'
import VideoRoutes from './views/pages/videos/router'
import WorkshopRoutes from './views/pages/Workshops/router'
import TecnovigilanciaRoutes from './views/pages/Tecnovigilancia/router'
import AnalysersRoutes from './views/pages/Analysers/routes'
import LogsRoutes from './views/pages/logs/routes'
import FilesRepository from './views/pages/FilesRepository/routes'
import BigDataDashboardRoutes from './views/pages/BigDataDashboard/router'
import SLAroutes from './views/pages/SLA/router'
import OrderAutomationRoutes from './views/pages/orderAutomation/router'
import ElectricalSafety from './views/pages/ElectricalSafety/routes'
import standardFilesRepositoryRoutes from './views/pages/StandardFilesRepository/routes'
import ElectricalSafetyPatternManage from './views/pages/ElectricalSafety/PatternManage/routes'
import calibrationV2Routes from './views/pages/CalibrationV2/routes'
import EquipmentCentralRoutes from './views/pages/EquipmentCentral/router'
import AvoidedCosts from './views/pages/AvoidedCosts/router'
import IAagentRoutes from './views/pages/IAagent/router'
import CriticalityMatrixRoutes from './views/pages/CriticalityMatrix/router'
import MyTasksRoutes from './views/pages/MyTasks/router'
import IndicationRoutes from './views/pages/Indication/router'
import IntegrationsRoutes from './views/pages/Integrations/router'
import SyntheticDashboardRoutes from './views/pages/SyntheticDashboard/router'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  mode: 'history',
  routes: [
    {
      path: '/integracoes',
      ...IntegrationsRoutes,
    },
    {
      path: '/my-tasks',
      ...MyTasksRoutes,
    },
    {
      path: '/IAagent',
      ...IAagentRoutes,
    },
    {
      path: '/slas',
      ...SLAroutes,
    },
    {
      path: '/criticalityMatrix',
      ...CriticalityMatrixRoutes,
    },
    {
      path: '/calibration/v2',
      ...calibrationV2Routes,
    },
    {
      path: '/equipment-central',
      ...EquipmentCentralRoutes,
    },
    {
      path: '/filesRepository',
      ...FilesRepository,
    },
    {
      path: '/standardFilesRepository',
      ...standardFilesRepositoryRoutes,
    },
    {
      path: '/analysers',
      ...AnalysersRoutes,
    },
    {
      path: '/inspectionRoutineChecklist',
      ...InspectionRoutineRoutes,
    },
    {
      path: '/tecnovigilancia',
      ...TecnovigilanciaRoutes,
    },
    {
      path: '/logs',
      ...LogsRoutes,
    },
    {
      path: '/workshops',
      ...WorkshopRoutes,
    },
    {
      path: '/videos',
      ...VideoRoutes,
    },
    {
      path: '/generatedReport/:link',
      ...GeneratedReportRoutes,
    },
    {
      path: '/chronogram',
      ...ChronogramRoutes,
    },
    {
      path: '/calendar',
      ...CalendarRoutes,
    },
    {
      path: '/auth',
      ...AuthRoutes,
    },
    {
      path: '/',
      redirect: '/auth',
    },
    {
      path: '/',
      redirect: '/auth',
    },
    {
      path: '/standard-manufacturer',
      ...StandardManufacturerRoutes,
    },
    {
      path: '/manufacturer',
      ...ManufacturerRoutes,
    },
    {
      path: '/replaceStudy',
      ...ReplacementStudyRoutes,
    },
    {
      path: '/schedule',
      ...ScheduleRoutes,
    },
    {
      path: '/solutions',
      ...SolutionRoutes,
    },
    {
      path: '/calibration',
      ...CalibrationRoutes,
    },
    {
      path: '/calleds',
      ...CalledsRoutes,
    },
    {
      path: '/checklists',
      ...ChecklistsRoutes,
    },
    {
      path: '/contracts',
      ...ContractsRoutes,
    },
    {
      path: '/stock',
      ...StockRoutes,
    },
    {
      path: '/consumption',
      ...ConsumptionRoutes,
    },
    {
      path: '/dashboard',
      ...DashboardRoutes,
    },
    {
      path: '/dashboard-bi',
      ...DashboardBIRoutes,
    },
    {
      path: '/big-data',
      ...BigDataRoutes,
    },
    {
      path: '/big-data-dashboard',
      ...BigDataDashboardRoutes,
    },
    {
      path: '/synthetic-dashboard',
      ...SyntheticDashboardRoutes,
    },
    {
      path: '/equipment',
      ...EquipmentRoutes,
    },
    {
      path: '/reports',
      ...ReportsRoutes,
    },
    {
      path: '/serviceOrders',
      ...ServiceOrdersRoutes,
    },
    {
      path: '/orderAutomation',
      ...OrderAutomationRoutes,
    },
    {
      path: '/tasks',
      ...TasksRoutes,
    },
    {
      path: '/users',
      ...UsersRoutes,
    },
    {
      path: '/unidades',
      ...UnidadesRoutes,
    },
    {
      path: '/calibrationMetrics',
      ...CalibrationMetricsRoutes,
    },
    {
      path: '/standardEquipments',
      ...StandardEquipamentRoutes,
    },
    {
      path: '/departments',
      ...DepartmentRoutes,
    },
    {
      path: '/suppliers',
      ...SupplierRoutes,
    },
    {
      path: '/uploadDocument',
      ...UploadDocumentRoutes,
    },
    {
      path: '/alert',
      ...AlertRoutes,
    },
    {
      path: '/institutions',
      ...InstitutionRoutes,
    },
    {
      path: '/costCenter',
      ...CostCenter,
    },
    {
      path: '/externalFileControl',
      ...ExternalFileControlRoutes,
    },
    {
      path: '/equipmentImport',
      ...EquipmentImportRoutes,
    },
    {
      path: '/patchNotes',
      ...PatchNoteRoutes,
    },
    {
      name: '',
      path: '/standardChecklist',
      ...StandardChecklistRoutes,
    },
    {
      name: 'aboutEquipmentQrCode',
      path: '/aboutEquipment/:equipmentId',
      component: AboutEquipmentQrCode,
      props: true,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresSolicitor: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'printServiceOrder',
      path: '/printServiceOrder/:institutionId/:serviceOrderId',
      component: ServiceOrderPrintView,
      props: true,
    },
    {
      name: 'printCalibrationCertified',
      path: '/printCalibrationCertified/:institutionId/:calibrationId',
      component: CalibrationPrintView,
      props: true,
    },
    {
      name: 'printChecklist',
      path: '/printChecklist/:checklistId',
      component: ChecklistPrintView,
      props: true,
    },
    {
      path: '/electricalSafety',
      ...ElectricalSafety,
    },
    {
      path: '/electricalSafety/patternManage/:id',
      ...ElectricalSafetyPatternManage,
    },
    {
      path: '/avoidedCosts',
      ...AvoidedCosts,
    },
    {
      name: 'indication',
      path: '/indication',
      component: () => import('./views/pages/Indication/indication.vue'),
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresSolicitor: true,
        requiresLaboratory: true,
      },
    },
    {
      path: '/referralAdmin',
      ...IndicationRoutes,
    },
    {
      name: 'referralComplete',
      path: '/referral/:token',
      component: () => import('./views/pages/Indication/referralComplete.vue'),
    },
  ],
})

async function redirectQrCodeToAuth(to, next) {
  const equipmentId = to.params.equipmentId
  const redirectUrl = await checkEquipmentMigration(equipmentId)

  if (redirectUrl) {
    window.location.href = redirectUrl
    return
  }

  setPendingQrCode(equipmentId)
  next('/auth')
}

router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem('token')
  let expiresToken = localStorage.getItem('expires')
  let user = JSON.parse(localStorage.getItem('user'))

  try {
    if (token && user && moment().isBefore(moment(expiresToken))) {
      let selectedInstitution = JSON.parse(localStorage.getItem('institution'))

      if (await checkMigrationAndRedirect(selectedInstitution, user)) return
    }
  } catch (err) {}

  if (to.meta.requiresAuth) {
    if (token) {
      if (moment().isBefore(moment(expiresToken))) {
        let institution = JSON.parse(localStorage.getItem('institution'))

        if (
          to.meta.module &&
          !institution.modules.split(',').includes(to.meta.module)
        ) {
          next('/userProfile')
          alert('Instituição logada não possui acesso a este módulo!')
        }

        if (
          to.meta.requiresPredial &&
          !institution.departmentTypes.includes(1)
        ) {
          next(from.path || '/userProfile')
          alert('Acesso restrito a instituições de manutenção predial!')
          return
        }

        // if (to.meta.requiresWorkshop) {
        //   if (institution.departmentTypes.includes(1)) {
        //     next(from.path)
        //   } else {
        //     next()
        //   }
        // }

        if (user.mainType == 0 && to.meta.requiresMaster) {
          next()
        } else if (user.mainType == 1 && to.meta.requiresAdmin) {
          next()
        } else if (
          (institution.userType == 2 || institution.userType == 8) &&
          to.meta.requiresSupervisor
        ) {
          next()
        } else if (institution.userType == 3 && to.meta.requiresOperator) {
          next()
        } else if (institution.userType == 4 && to.meta.requiresCoordOp) {
          next()
        } else if (institution.userType == 5 && to.meta.requiresCoordSector) {
          next()
        } else if (institution.userType == 6 && to.meta.requiresSolicitor) {
          next()
        } else if (institution.userType == 7 && to.meta.requiresLaboratory) {
          next()
        } else {
          if (from.path != '/auth') {
            next('/auth')
          }
          alert('Acesso Restrito')
        }
      } else if (to.name == 'aboutEquipmentQrCode') {
        await redirectQrCodeToAuth(to, next)
      } else {
        next('/auth')
      }
    } else if (to.name == 'aboutEquipmentQrCode') {
      await redirectQrCodeToAuth(to, next)
    } else {
      next('/auth')
    }
  } else {
    next()
  }
})

export default router
